// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CreateSkillset__CreateSkillset___13S0w{padding:24px 16px 14px 16px}.CreateSkillset__CreateSkillsetFooter___16YK8{position:relative;margin-top:32px;padding-top:14px;display:flex;justify-content:flex-end}.CreateSkillset__CreateSkillsetFooter___16YK8::after{content:'';position:fixed;width:100%;height:1px;background:#d5d5d5;left:0;transform:translateY(-13px)}.CreateSkillsetInput-textinput{border-radius:4px;padding:3px 9px}\n", ""]);
// Exports
exports.locals = {
	"CreateSkillset": "CreateSkillset__CreateSkillset___13S0w",
	"CreateSkillsetFooter": "CreateSkillset__CreateSkillsetFooter___16YK8"
};
module.exports = exports;
